export var makeRequestErrorFromResponse = function (type, response) {
    var _a, _b;
    return {
        type: type,
        response: response,
        message: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : null,
    };
};
export var makeRequestError = function (type, message) {
    if (message === void 0) { message = null; }
    return {
        type: type,
        response: null,
        message: message,
    };
};
//# sourceMappingURL=makeRequestError.js.map